import { render, staticRenderFns } from "./ClientesAtivosChart.vue?vue&type=template&id=12d8588d"
import script from "./ClientesAtivosChart.vue?vue&type=script&lang=js"
export * from "./ClientesAtivosChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports